'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseReportController = require('../../baseReportController');

var _baseReportController2 = _interopRequireDefault(_baseReportController);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LastLoginController = function (_BaseReportController) {
  (0, _inherits3.default)(LastLoginController, _BaseReportController);

  function LastLoginController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, LastLoginController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LastLoginController.__proto__ || (0, _getPrototypeOf2.default)(LastLoginController)).call(this, reportingService, loadingService, utilsService));

    if (!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) {
      return (0, _possibleConstructorReturn3.default)(_this);
    }

    _this.authService = authService;
    _this.reportingService = reportingService;
    _this.userService = userService;
    _this.enums = enums;
    _this.loadingService = loadingService;
    _this.lookupService = lookupService;
    _this.$q = $q;
    _this.$scope = $scope;
    _this.printService = printService;
    _this.exportService = exportService;
    _this.utilsService = utilsService;

    _this.reportCriteria = {};
    _this.dtPopups = {};
    _this.errMsgs = [];

    _this.panels = {
      reportCriteria: true,
      reportSummary: false,
      reportData: false
    };

    _this.summary = [];
    _this.locationDetailsHidden = [];

    _this.reset();
    return _this;
  }

  (0, _createClass3.default)(LastLoginController, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.$broadcast('reports:reset');

      this.summary = [];

      this.errMsgs = [];

      this.reportCriteria.additionalParameter1 = "0";
    }
  }, {
    key: 'runReport',
    value: function runReport() {
      this.panels.reportData = true;

      this.$scope.$broadcast('reports:runReport', {
        action: 'lastLogin',
        criteriaValidator: this.validateCriteria.bind(this),
        criteriaParser: this.parseCriteria.bind(this)
      });
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      this.errMsgs = [];

      return this.errMsgs.length === 0;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      this.parseStartAndEndDate(parsedCriteria);
      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;

      return parsedCriteria;
    }
  }, {
    key: 'printReport',
    value: function printReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.printService.printReport('Last Login', this.parseCriteria());
    }
  }, {
    key: 'exportReport',
    value: function exportReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.exportService.exportReport('Last Login', this.parseCriteria());
    }
  }]);
  return LastLoginController;
}(_baseReportController2.default);

exports.default = LastLoginController;


// WEBPACK FOOTER //
// ./client/app/components/reports/adminReports/lastLogin/lastLogin.controller.js